module.exports = __webpack_public_path__ + "static/media/logo_ncsu.35121215.png";